import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import classes from "./blogPost.module.css";
import Footer from "../../components/footer";
import { blogPosts } from "../../data/blogPosts";

export const BlogPost = () => {
  const { slug } = useParams();

  // Find the post by slug
  const post = blogPosts.find((post) => post.slug === slug);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [slug]);

  if (!post) {
    return (
      <div className={classes.postContainer}>
        <h1>Post Not Found</h1>
        <p>We couldn't find the blog post you're looking for.</p>
        <Link to="/blog">Return to Blog</Link>
      </div>
    );
  }

  return (
    <>
      <div className={classes.postContainer}>
        <nav className={classes.breadcrumbs}>
          <Link to="/" className={classes.breadcrumbLink}>
            Home
          </Link>
          <span className={classes.breadcrumbSeparator}>/</span>
          <Link to="/blog" className={classes.breadcrumbLink}>
            Blog
          </Link>
          <span className={classes.breadcrumbSeparator}>/</span>
          <span className={classes.breadcrumbCurrent}>{post.title}</span>
        </nav>

        <article className={classes.postContent}>
          <div className={classes.postHeader}>
            <h1 className={classes.postTitle}>{post.title}</h1>

            <div className={classes.postMeta}>
              <div className={classes.authorDate}>
                <span className={classes.author}>By {post.author}</span>
                <span className={classes.date}>{post.date}</span>
              </div>
              <div className={classes.category}>{post.category}</div>
            </div>
          </div>

          <div className={classes.featuredImageContainer}>
            <img
              src={post.image}
              alt={post.title}
              className={classes.featuredImage}
            />
          </div>

          <div className={classes.postBody}>
            <div
              className={classes.postText}
              dangerouslySetInnerHTML={{ __html: post.content }}
            />

            <div className={classes.tagsSection}>
              <h4 className={classes.tagsTitle}>Tags</h4>
              <div className={classes.tagsList}>
                {post.tags.map((tag, index) => (
                  <Link
                    key={index}
                    to={`/blog/tag/${tag.toLowerCase().replace(/\s+/g, "-")}`}
                    className={classes.tag}
                  >
                    {tag}
                  </Link>
                ))}
              </div>
            </div>

            {/* Continue with author bio and related posts... */}
          </div>
        </article>
      </div>
      <Footer />
    </>
  );
};
